import React from "react";
import classNames from "classnames";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import {Card, CardContent} from "@material-ui/core";
import APPCONFIG from "constants/Config";
import moment from "moment";

export default class Admins extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Admins._name, 'GET_TABLE');
		super(props, model);
		this.request = 'GET_TABLE';

	}


	render() {
		const {data, pages, limit, loading} = this.state;
		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Admins')}
								<Button color="secondary" onClick={this.reloadTable}><i
									className={"fa fa-refresh"}/></Button>
								</div>

								<div className="ml-auto refresh">

								</div>
							</div>
						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "Email",
									id: "email",
									accessor: (obj) => obj.email
								},
								{
									Header: "First Name",
									id: "first_name",
									accessor: (obj) => obj.name_first
								},
								{
									Header: "Last Name",
									id: "Last Name",
									accessor: (obj) => obj.name_last
								},
								{
									Header: "Last Logged In",
									id: "last_logged_in",
									accessor: (obj) => obj.last_logged_in
								},
								{
									Header: "Last IP",
									id: "last_ip",
									accessor: (obj) => obj.last_ip
								},


							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={pages > 1}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}